import { object, string, array, number } from 'yup'
import { ISearchWarehouse } from '../../interfaces/Warehouse/Warehouse'

export const searchInitialState: ISearchWarehouse = {
  warehouseCode: '',
  warehouseName: '',
  warehouseAddress: '',
  warehouseDescription: ''
}

export const createInitialValue = {
  id: 0,
  warehouseCode: '',
  postalCode: '',
  warehouseDescription: '',
  warehouseAdrress: '',
  warehouseName: '',
  warehouseSchedule: [],
  active: false
}

export const warehouseValidationSchema = object({
  warehouseCode: string()
    .trim()
    .required('El campo código de almacén es requerido.')
    .max(50, 'Máximo 50 caracteres.'),
  warehouseDescription: string()
    .trim()
    .required('El campo descripción de almacén es requerido.')
    .max(200, 'Máximo 200 caracteres.'),
  warehouseAddress: string()
    .trim()
    .required('El campo dirección de almacén es requerido.')
    .min(5, 'Debe ingresar a lo menos 5 caracteres')
    .max(100, 'Máximo 100 caracteres.'),
  postalCode: string()
    .trim()
    .required('El campo código postal es requerido.')
    .min(2, 'Debe ingresar a lo menos 3 caracteres')
    .max(50, 'Máximo 50 caracteres.'),
  warehouseName: string()
    .trim()
    .required('El campo nombre de almacén es requerido.')
    .min(2, 'Debe ingresar a lo menos 3 caracteres')
    .max(50, 'Máximo 50 caracteres.'),
  warehouseSchedule: array(
    object({
      dayId: number()
        .required('Debe seleccionar un día de la semana')
        .min(1)
        .max(7),
      start: string().required('Debe ingresar una hora de apertura'),
      end: string().required('Debe ingresar una hora de cierre')
    })
  )
    .max(7)
    .test(
      'onHorarioValidation',
      'Debe seleccionar horarios correctos',
      (warehouseSchedule) => {
        if (warehouseSchedule !== undefined) {
          const sum = warehouseSchedule.filter(
            (schedule) => `${schedule.start!}:00` > `${schedule.end!}:00`
          )

          return sum.length === 0
        }

        return true
      }
    )
    .test(
      'onHorarioValidation2',
      'No pueden existir días cuyo horario de apertura y cierre sean iguales.',
      (warehouseSchedule) => {
        if (warehouseSchedule !== undefined) {
          const sum = warehouseSchedule.filter(
            (schedule) => `${schedule.start!}:00` === `${schedule.end!}:00`
          )

          return sum.length === 0
        }

        return true
      }
    )
    .test(
      'onDaysValidation',
      'No se deben repetir días',
      (warehouseSchedule) => {
        if (warehouseSchedule !== undefined) {
          return (
            warehouseSchedule.map((item) => item.dayId).length ===
            new Set(warehouseSchedule.map((item) => item.dayId)).size
          )
        }

        return true
      }
    )
})
